module.exports = __webpack_public_path__ + "static/media/RaisingChildren_android_2.2516256c.jpg";